import React from 'react';
import cn from 'classnames';

import {IIconProps} from './IIcon';

const Icon = ({name, title, width, height, onClick, classNames, ariaLabel}: IIconProps) => {
	return (
		<svg
			className={cn(`icon-${name}-dims`, classNames)}
			width={width || 24}
			height={height || 24}
			aria-label={ariaLabel || title || name}
			onClick={onClick}
		>
			{!!title && <title>{title}</title>}
			<use xlinkHref={`#icon-${name}`} />
		</svg>
	);
};

export default Icon;
